import { render, staticRenderFns } from "./explain.vue?vue&type=template&id=0dea685a&scoped=true"
import script from "./explain.vue?vue&type=script&lang=ts"
export * from "./explain.vue?vue&type=script&lang=ts"
import style0 from "./explain.vue?vue&type=style&index=0&id=0dea685a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dea685a",
  null
  
)

export default component.exports